module.exports = __webpack_public_path__ + "static/img/Partner 2.bd469a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Partner 2.png
// module id = i/jz
// module chunks = 13